export const getMaxHeight = elm => {
    let maxHeight = 0;

    for (let i = 0; i < elm.length; i++) {
        const el = elm[i];
        if (el.offsetHeight > maxHeight) {
            maxHeight = el.offsetHeight;
        }
    }

    return maxHeight;
};

export const updateHeight = (elm, maxHeight) => {
    for (let i = 0; i < elm.length; i++) {
        const el = elm[i];
        el.style.height = maxHeight + 'px';
    }
};

// let items = document.querySelectorAll('.compare-col__item');
// let itemsMaxHeight = getMaxHeight(items);
// updateHeight(items, itemsMaxHeight);
//
// let groupTitles = document.querySelectorAll('.compare-col__group-title');
// let groupTitlesMaxHeight = getMaxHeight(groupTitles);
// updateHeight(groupTitles, groupTitlesMaxHeight);
